import { graphql, readInlineData } from "react-relay";

import type { helpersCheckHasSeriesShortLabelContent$key } from "scmp-app/queries/__generated__/helpersCheckHasSeriesShortLabelContent.graphql";

export const checkHasSeriesShortLabel = (reference: helpersCheckHasSeriesShortLabelContent$key) => {
  const data = readInlineData(
    graphql`
      fragment helpersCheckHasSeriesShortLabelContent on Content @inline {
        ... on Article {
          seriesShortLabel
          seriesContainer {
            seriesShortLabel
          }
        }
      }
    `,
    reference,
  );

  return !!data.seriesContainer?.seriesShortLabel || !!data.seriesShortLabel;
};
